import type { ReadonlyDeep } from 'type-fest';
import type { DataItem as DetailedJobProductsTableDataItem } from '@/components/tables/DetailedJobProductsTable.vue';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { getStrCell } from '@/utils/file';

export function getTableItem(
  product: ReadonlyDeep<openapi.ProductOpenapi>,
): DetailedJobProductsTableDataItem {
  return {
    id: product.id,
    model: getStrCell(product.model),
    serialNumber: getStrCell(product.serial),
    description: getStrCell(product.description),
    quantId: product.quant_id,
    quantity: getStrCell(product.pieces),
    scannedQty: getStrCell(product.confirmation?.confirmed_pieces),
    type: getStrCell(product.type_code),
    pickingStatus: product.picking_status,
  };
}
